import React from 'react';
import { Box, Stack } from '@mui/material';
import { BusinessOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import { CompanyNameEdit, DbaEdit, VendorNumberEdit, VendorStatusEdit } from '../fields';

export const VendorIdentificationSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader
        icon={<BusinessOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Identification"
      />
      <SectionPaper>
        <Stack spacing={2}>
          <Stack direction="row" gap={2}>
            <CompanyNameEdit />
            <DbaEdit />
          </Stack>
          <Stack direction="row" gap={2}>
            <VendorNumberEdit />
            <VendorStatusEdit />
          </Stack>
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default VendorIdentificationSection;
